import { css } from '@emotion/react'
import styled from '@emotion/styled'
export const StylePaginationWrapper = styled.div<{ hide?: boolean }>`
  justify-content: space-between;
  padding: 14px 0;
  align-items: center;
  font-weight: 300;
  display: none;
  ${(props) =>
    props.hide &&
    css`
      display: flex;
    `}

  @media (max-width: 768px) {
    ${(props) =>
      props.hide &&
      css`
        display: flex;
        flex-direction: column-reverse;
        row-gap: 10px;
      `}
  }
`

export const StyleCountWrapper = styled.p`
  color: ${(props: any) => props.theme.colors.text};
  font-size: 14px;
  letter-spacing: 0.25px;
  line-height: 20px;
`

export const StylePaginationButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px;
`

export const StylePaginationButton = styled.button<{ $active?: boolean }>`
  width: fit-content;
  padding: 8px 14px;
  border-radius: 10px;
  border: 0;
  font-weight: 350;
  font-size: 16px;
  background-color: transparent;
  color: ${(props: any) => props.theme.colors.text};
  text-align: center;
  cursor: pointer;
  transition: all 300ms linear;
  &:hover {
    background-color: ${(props: any) => props.theme.colors.primaryLight};
  }
  ${(props: any) =>
    props.$active &&
    css`
      background-color: ${props.theme.colors.primaryLight};
    `}
  svg {
    transform: translateY(3px);
  }
`
